var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0059 12L6.98413 7.97822C6.70961 7.70371 6.70961 7.25864 6.98413 6.98413C7.25864 6.70961 7.70371 6.70961 7.97822 6.98413L12 11.0059L16.0218 6.98413C16.2963 6.70961 16.7414 6.70961 17.0159 6.98413C17.2904 7.25864 17.2904 7.70371 17.0159 7.97822L12.9941 12L17.0159 16.0218C17.2904 16.2963 17.2904 16.7414 17.0159 17.0159C16.7414 17.2904 16.2963 17.2904 16.0218 17.0159L12 12.9941L7.97822 17.0159C7.70371 17.2904 7.25864 17.2904 6.98413 17.0159C6.70961 16.7414 6.70961 16.2963 6.98413 16.0218L11.0059 12ZM12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 22.5941C17.851 22.5941 22.5941 17.851 22.5941 12C22.5941 6.14902 17.851 1.40586 12 1.40586C6.14902 1.40586 1.40586 6.14902 1.40586 12C1.40586 17.851 6.14902 22.5941 12 22.5941Z",
    fill: "#162056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.40f8fddd76a56c368b5903bf68166107.svg";
export { ForwardRef as ReactComponent };